import React, { useState } from "react"
import { useHistory } from "react-router-dom"
import DeleteModal from "components/Common/DeleteModal"
import { deleteRole, getRoles } from "api/roles"
import { usePagination } from "hooks/usePagination"
import ResultHandler from "components/ResultHandler"
import PaginationHandler from "components/PaginationHandler"
import TableHeaderHandler from "components/TableHeaderHandler"
import { PERMISSIONS } from "api/permissions"
import { useTranslation } from "react-i18next"
import { useResponse } from "hooks/useResponse"
import TableAction from "components/TableAction"
import EmptyData from "components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

export default function RolesTable() {

  const { t } = useTranslation()

  const navigate = useHistory()

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
  } = usePagination(getRoles)

  const [show, setShow] = useState(false)

  function onCloseClick() {
    setShow(false)
  }

  const [deletingRole, setDeletingRole] = useState(null)

  const { setData } = useResponse(deleteRole, () => {
    setShow(false)
    setDeletingRole(null)
    setPayload({})
  })

  function onDeleteClick() {
    setData({ type: "add", data: deletingRole })
  }

  return (
    <>
      <TableHeaderHandler
        permission={PERMISSIONS.ROLE_CREATE}
        setPage={setPage}
        setPerPage={setPerPage}
        addUrl="/add-role"
      />
      <div className="table-rep-plugin">

        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th style={{ width: "70%" }}>{t("forms.Name")}</Th>
                <Th style={{ width: "30%" }}>{t("tables.Action")}</Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.roles.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td>{row.name}</Td>
                      <Td>
                        <TableAction
                          hasEdit={true}
                          hasDelete={true}
                          editPermission={PERMISSIONS.ROLE_EDIT}
                          deletePermission={PERMISSIONS.ROLE_DELETE}
                          type="role"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingRole}
                        />
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>
          {!loading &&
            <EmptyData empty={response.data && response.data.roles.length === 0} msg="No Roles Found." />
          }
          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}
          <ResultHandler error={error} loading={loading} />
        </div>
      </div>
    </>
  )
}
